import { BaseApiType } from './baseApi'
import { EmrSyncStatusCode } from '../../shared/generated.types'
import { patientRegistrationApi } from '../patientRegistration'

export default function enhanceEndpoints(api: BaseApiType) {
  return api.enhanceEndpoints({
    endpoints: {},
  })
}
